(function () {
  const hero = document.querySelector('.vc-campaign-hero');
  if (!hero) return;

  const video         = hero.querySelector('.vc-campaign-hero__video--desktop');
  const mobileVideo   = hero.querySelector('.vc-campaign-hero__video--mobile');
  const playBtn       = hero.querySelector('[data-hero-play]');
  const muteBtn       = hero.querySelector('[data-hero-mute]');
  const fullscreenBtn = hero.querySelector('[data-hero-fullscreen]');

  /* ── Poster fade-out once the video is actually rendering frames ── */
  [
    [video, '.vc-campaign-hero__poster--desktop'],
    [mobileVideo, '.vc-campaign-hero__poster--mobile'],
  ].forEach(function (pair) {
    const v = pair[0];
    const poster = hero.querySelector(pair[1]);
    if (!v || !poster) return;
    const hide = function () { poster.classList.add('is-hidden'); };
    v.addEventListener('playing', hide, { once: true });
    if (!v.paused && v.readyState >= 3) hide();
  });

  /* ── Suspend media once the hero is scrolled out ──
     Uses the same scroll range as the header background switch (hero bottom
     crossing the viewport top). Only videos that were playing are resumed, and
     sound stays off: the user re-enables it via the mute button. */
  let resumeList = [];

  function suspendMedia() {
    resumeList = [video, mobileVideo].filter(function (v) { return v && !v.paused; });
    resumeList.forEach(function (v) { v.pause(); });
    if (video && !video.muted) {
      video.muted = true;
      if (muteBtn) muteBtn.setAttribute('aria-pressed', 'false');
    }
  }

  function resumeMedia() {
    resumeList.forEach(function (v) { v.play().catch(function () {}); });
    resumeList = [];
  }

  /* ── Pin hero; following sections slide over it ──
     CSS position:sticky fails inside ScrollSmoother, so pin via ScrollTrigger. */
  window.addEventListener('vc:scroll-ready', function () {
    if (typeof ScrollTrigger === 'undefined') return;

    ScrollTrigger.create({
      trigger: hero,
      start: 'top top',
      end: 'bottom top',
      pin: true,
      pinSpacing: false,
      onLeave: suspendMedia,
      onEnterBack: resumeMedia,
    });

    var heroWrapper = hero.closest('.shopify-section') || hero.parentElement;
    var sibling = heroWrapper ? heroWrapper.nextElementSibling : null;
    var idx = 1;
    while (sibling) {
      sibling.classList.add('vc-campaign-hero-overlap');
      sibling.style.position = 'relative';
      sibling.style.zIndex = String(idx++);
      sibling = sibling.nextElementSibling;
    }

    /* Overlap margins change layout height after the triggers were measured */
    ScrollTrigger.refresh();
  }, { once: true });

  /* ── Deferred video start ──
     Videos ship with preload="none" and no autoplay attribute, so the poster
     paints first and no video bytes compete with the initial page load. Only
     the video matching the viewport is started, after window load. */
  const mobileQuery = window.matchMedia('(max-width: 991px)');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const saveData = !!(navigator.connection && navigator.connection.saveData);
  const autoplayAllowed = !reduceMotion && !saveData;

  function startActiveVideo() {
    if (!autoplayAllowed) return;
    if (hero.getBoundingClientRect().bottom <= 0) return;
    const active = mobileQuery.matches ? mobileVideo : video;
    if (active && active.paused) {
      /* iOS only honours autoplay when the muted state is set before play() */
      active.defaultMuted = true;
      active.muted = true;
      active.play().catch((err) => {
        console.warn('[hero] video autoplay rejected:', err && err.name);
        /* Autoplay rejected (e.g. iOS Low Power Mode): retry on the first tap, since
           the mobile hero has no play button. */
        autoplayBlocked = true;
        active.dispatchEvent(new Event('pause'));
      });
    }
  }

  let autoplayBlocked = false;
  ['touchend', 'pointerup', 'click'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      if (!autoplayBlocked) return;
      if (e.target.closest && e.target.closest('button, a, input, [role="button"]')) return;
      autoplayBlocked = false;
      startActiveVideo();
    }, { passive: true });
  });

  if (document.readyState === 'complete') startActiveVideo();
  else window.addEventListener('load', startActiveVideo, { once: true });

  if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', startActiveVideo);

  if (!video) return;

  const EASE     = 'cubic-bezier(0.7, 0.1, 0.3, 1)';
  const DUR_FAST = 0.2;
  const DUR_BASE = 0.35;

  /* ── Video play state ── */
  function syncPlayState() {
    hero.dataset.playing = video.paused ? 'false' : 'true';
  }

  video.addEventListener('play',  syncPlayState);
  video.addEventListener('pause', syncPlayState);

  /* ── Play / Pause button (DrawSVG) ── */
  if (playBtn) {
    const playIcon  = playBtn.querySelector('[data-icon="play"]');
    const pauseIcon = playBtn.querySelector('[data-icon="pause"]');
    const playPaths  = playIcon  ? playIcon.querySelectorAll('path')  : [];
    const pausePaths = pauseIcon ? pauseIcon.querySelectorAll('path') : [];

    /* Initial state: show pause icon when the video will autoplay, play icon otherwise */
    gsap.set(playPaths,  { drawSVG: '100%' });
    gsap.set(pausePaths, { drawSVG: '100%' });
    gsap.set(playIcon,   { autoAlpha: autoplayAllowed ? 0 : 1 });
    gsap.set(pauseIcon,  { autoAlpha: autoplayAllowed ? 1 : 0 });

    function showPlay() {
      gsap.to(pausePaths, { drawSVG: '0%', duration: DUR_FAST, ease: EASE,
        onComplete() {
          gsap.set(pauseIcon, { autoAlpha: 0 });
          gsap.set(playIcon,  { autoAlpha: 1 });
          gsap.fromTo(playPaths, { drawSVG: '0%' }, { drawSVG: '100%', duration: DUR_BASE, ease: EASE });
        }
      });
    }

    function showPause() {
      gsap.to(playPaths, { drawSVG: '0%', duration: DUR_FAST, ease: EASE,
        onComplete() {
          gsap.set(playIcon,  { autoAlpha: 0 });
          gsap.set(pauseIcon, { autoAlpha: 1 });
          gsap.fromTo(pausePaths, { drawSVG: '0%' }, { drawSVG: '100%', duration: DUR_BASE, ease: EASE });
        }
      });
    }

    playBtn.addEventListener('click', () => {
      if (video.paused) {
        video.play();
        showPause();
      } else {
        video.pause();
        showPlay();
      }
    });

    /* Sync icon if video pauses externally */
    video.addEventListener('play',  showPause);
    video.addEventListener('pause', showPlay);
  }

  /* ── Sound equalizer (live loop when unmuted) ── */
  if (muteBtn) {
    const soundPaths = Array.from(muteBtn.querySelectorAll('path'));

    /* Original and compressed d values for each line */
    const lineStates = [
      { full: 'M6 3V13',   mini: 'M6 7V9'      },
      { full: 'M10 3V13',  mini: 'M10 5.5V10.5' },
      { full: 'M8 5V11',   mini: 'M8 7V9'       },
      { full: 'M4 6V10',   mini: 'M4 7.5V8.5'   },
      { full: 'M12 6V10',  mini: 'M12 7.5V8.5'  },
    ];

    const durations = [0.45, 0.60, 0.38, 0.54, 0.42];
    let equalizerTweens = [];

    function startEqualizer() {
      equalizerTweens = soundPaths.map((path, i) => {
        const { mini } = lineStates[i];
        return gsap.to(path, {
          attr: { d: mini },
          duration: durations[i],
          ease: 'sine.inOut',
          repeat: -1,
          yoyo: true,
          delay: i * 0.08,
        });
      });
    }

    function stopEqualizer() {
      equalizerTweens.forEach(t => t.kill());
      equalizerTweens = [];
      soundPaths.forEach((path, i) => {
        gsap.to(path, { attr: { d: lineStates[i].full }, duration: DUR_BASE, ease: EASE });
      });
    }

    /* Equalizer runs only when playing AND unmuted */
    video.addEventListener('play',  () => { if (!video.muted) startEqualizer(); });
    video.addEventListener('pause', stopEqualizer);

    if (!video.paused && !video.muted) startEqualizer();

    muteBtn.addEventListener('click', () => {
      video.muted = !video.muted;
      muteBtn.setAttribute('aria-pressed', String(!video.muted));
      /* Equalizer reflects mute state: paused lines when muted */
      if (video.muted) {
        stopEqualizer();
      } else if (!video.paused) {
        startEqualizer();
      }
    });
  }

  /* ── Fullscreen (bracket corner animation) ── */
  if (fullscreenBtn) {
    const corners = fullscreenBtn.querySelectorAll('path');
    const CORNER_OFFSETS = [
      { x: -2, y: -2 },
      { x: -2, y:  2 },
      { x:  2, y: -2 },
      { x:  2, y:  2 },
    ];

    function cornersOut(ease) {
      corners.forEach((corner, i) => {
        gsap.to(corner, { x: CORNER_OFFSETS[i].x, y: CORNER_OFFSETS[i].y, duration: DUR_BASE, ease });
      });
    }

    function cornersIn(ease) {
      corners.forEach(corner => {
        gsap.to(corner, { x: 0, y: 0, duration: DUR_BASE, ease });
      });
    }

    fullscreenBtn.addEventListener('mouseenter', () => cornersOut(EASE));
    fullscreenBtn.addEventListener('mouseleave', () => {
      if (!(document.fullscreenElement || document.webkitFullscreenElement)) cornersIn(EASE);
    });

    /* Safari < 16.4 only exposes the webkit-prefixed API; iPhone Safari only
       supports fullscreen on the <video> element itself. */
    const getFsElement = () => document.fullscreenElement || document.webkitFullscreenElement;

    function enterFullscreen() {
      const request = hero.requestFullscreen || hero.webkitRequestFullscreen;
      if (request) {
        const result = request.call(hero);
        if (result && result.catch) result.catch(() => {});
      } else if (video.webkitEnterFullscreen) {
        video.webkitEnterFullscreen();
      }
    }

    function exitFullscreen() {
      const exit = document.exitFullscreen || document.webkitExitFullscreen;
      if (exit) exit.call(document);
    }

    fullscreenBtn.addEventListener('click', () => {
      if (getFsElement()) exitFullscreen();
      else enterFullscreen();
    });

    const onFullscreenChange = () => {
      /* CSS fades the overlay text out while the hero is fullscreen */
      hero.toggleAttribute('data-fullscreen', getFsElement() === hero);
      if (!getFsElement()) cornersIn('back.out(1.4)');
    };
    document.addEventListener('fullscreenchange', onFullscreenChange);
    document.addEventListener('webkitfullscreenchange', onFullscreenChange);
  }

  syncPlayState();
})();
